import { render } from "./Introduction.vue?vue&type=template&id=39c372d2"
const script = {}

import "./Introduction.vue?vue&type=style&index=0&id=39c372d2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__